import React from 'react';
import './Pricing.css';

function Pricing() {
  const plans = [
    {
      name: 'Básico',
      price: '187',
      users: '3 usuarios',
      features: [
        'Gestión de órdenes de trabajo',
        'Asignación de técnicos',
        'Registro de clientes',
        'App móvil para técnicos',
        'Reportes básicos',
        'Soporte por email'
      ],
      popular: false
    },
    {
      name: 'Profesional',
      price: '229',
      users: '5 usuarios',
      features: [
        'Todo lo del plan Básico',
        'Rutas optimizadas',
        'Presupuestos y facturación',
        'Reportes avanzados',
        'Historial completo de clientes',
        'Soporte prioritario',
        'Integraciones'
      ],
      popular: true
    },
    {
      name: 'Completo',
      price: '270',
      users: '5 usuarios + IA',
      features: [
        'Todo lo del plan Profesional',
        '🤖 Agente IA incluido',
        'Programación inteligente',
        'Respuestas automáticas',
        'Análisis predictivo',
        'Optimización de recursos',
        'Soporte 24/7'
      ],
      popular: false
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="pricing" className="pricing section">
      <div className="container">
        <h2 className="section-title">Planes Simples y Transparentes</h2>
        <p className="section-subtitle">
          Elige el plan que mejor se adapte a tu empresa. Sin costos ocultos.
        </p>
        <p className="billing-label">📅 Facturación Anual</p>
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.popular ? 'popular' : ''}`}>
              {plan.popular && <div className="popular-badge">Más Popular</div>}
              <h3 className="plan-name">{plan.name}</h3>
              <div className="plan-price">
                <span className="currency">S/</span>
                <span className="amount">{plan.price}</span>
                <span className="period">/mes</span>
              </div>
              <p className="plan-users">{plan.users}</p>
              <ul className="plan-features">
                {plan.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="check">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <button className="btn btn-primary btn-full" onClick={scrollToContact}>
                Comenzar Ahora
              </button>
            </div>
          ))}
        </div>
        <div className="pricing-note">
          <p>💡 Todos los planes incluyen actualizaciones gratuitas y migración de datos sin costo</p>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
